import { Outlet } from "react-router";
import NavRFQ from "./NavRFQ";
import { WebsocketRfqProvider } from "@/lib/websocket/WebsocketRfqProvider";
import { SelectedQuoteRevisionIdProvider } from "../SelectedQuoteRevisionIdContext/SelectedQuoteRevisionIdProvider";
import CollapseSidebar from "../toggleSidebar/CollapseSidebar";
import { useContext } from "react";
import ToggleSidebarContext from "../toggleSidebar/ToggleSidebarContext";

export default function Layout() {
  const { collapseSidebar } = useContext(ToggleSidebarContext);

  return (
    <WebsocketRfqProvider>
      <SelectedQuoteRevisionIdProvider>
        <div className="h-full flex">
          {!collapseSidebar && <NavRFQ />}
          {!collapseSidebar && <CollapseSidebar />}
          <div className="h-full grow overflow-y-auto bg-slate-100">
            <Outlet />
          </div>
        </div>
      </SelectedQuoteRevisionIdProvider>
    </WebsocketRfqProvider>
  );
}
